module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('clip-loader', {
    attrs: {
      "loading": _vm.fetchingData,
      "color": '#000'
    }
  }), _vm._v(" "), (!_vm.fetchingData) ? _c('div', _vm._l((_vm.requiredDocuments), function(document, index) {
    return _c('Document', {
      key: index,
      attrs: {
        "document": document
      },
      on: {
        "document:created": function($event) {
          return _vm.documentCreated($event, index)
        },
        "document:submitted": function($event) {
          return _vm.documentSubmitted($event, index)
        }
      }
    })
  }), 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6505d92e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Organization/Documents.vue
// module id = 810
// module chunks = 1